// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__2Z32t","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__P7D1v"};